import { useEffect, useMemo, useRef, useState } from "react";

export const useMinDurationLoading = (
  isFetching: boolean,
  triggerState: unknown,
  minDuration = 400,
): boolean => {
  const [showLoading, setShowLoading] = useState(false);
  const loadingTimer = useRef<ReturnType<typeof setTimeout> | null>(null);
  const loadingStart = useRef<number | null>(null);

  const triggerString = useMemo(
    () => JSON.stringify(triggerState),
    [triggerState],
  );
  const prevTriggerRef = useRef(triggerString);

  useEffect(() => {
    const triggerChanged = prevTriggerRef.current !== triggerString;
    prevTriggerRef.current = triggerString;

    if (isFetching || triggerChanged) {
      if (loadingTimer.current) clearTimeout(loadingTimer.current);
      loadingStart.current = Date.now();
      setShowLoading(true);
    }

    if (!isFetching && loadingStart.current !== null) {
      const elapsed = loadingStart.current
        ? Date.now() - loadingStart.current
        : 0;
      const remaining = Math.max(0, minDuration - elapsed);
      loadingTimer.current = setTimeout(() => setShowLoading(false), remaining);
    }

    return () => {
      if (loadingTimer.current) clearTimeout(loadingTimer.current);
    };
  }, [isFetching, triggerString, minDuration]);

  return showLoading;
};
